module.exports = __webpack_public_path__ + "static/media/linkedin.94d9daa1.svg";